{
  "favorites_title": "Избранные",
  "favorites_empty": "Список пуст",
  "favorites_hidden_guests": "У вас {{count}} скрытых гостевых закладок.",
  "favorites_premium_required": "Доступны при активном Премиуме",
  "favorites": {
    "warning_inactive": "Не входил более {{days}} дней",
    "warning_registered": "Ник зарегистрирован"
  },
  "privacy_settings": "Настройки приватности",
  "private_messages_privacy": "Личные сообщения",
  "privacy_allow_all": "Разрешить всем",
  "privacy_favorites_only": "Только от избранных",
  "privacy_disabled": "Запретить совсем",
  "private_messages_reset_notification": "Срок действия Премиума истек. Настройки личных сообщений сброшены на \"Разрешить всем\"",
  "add_favorite_guest_warning_title": "Добавление гостя",
  "add_favorite_guest_warning_body": "Этот пользователь не зарегистрирован. В следующий раз под этим ником может оказаться другой человек.",
  "understand_and_add": "Понимаю, добавить",
  "add_to_favorites": "Добавить в избранное",
  "remove_from_favorites": "Удалить из избранного",
  "keep_in_favorites": "Оставить в избранном",
  "favorite_warning": "Внимание! Нажмите для подробностей",
  "favorite_user": "В избранном",
  "favorites_limit_exceeded": "Достигнут лимит избранных",
  "favorites_guest_requires_premium": "Добавление гостевых записей доступно только при активном Премиуме",
  "favorites_already_exists": "Пользователь уже в избранном",
  "favorites_cannot_add_self": "Нельзя добавить самого себя в избранное",
  "favorites_only_for_registered": "Данный функционал доступен только зарегистрированным пользователям",
  "chat_title": "Вирт чат",
  "partners_title": "Наши партнеры",
  "login_title": "Вход",
  "chat_long_title": "Виртуальный секс чат без регистрации – воплотите все свои фантазии на сайте Virt-Chat",
  "site_description": "На сайте Virt-Chat можно воплотить в жизнь все свои самые смелые фантазии! Виртуальный секс-чат позволит вам общаться без регистрации, обмениваться фотографиями и gif-анимацией, а также быстро находить свободных девушек и парней онлайн. Полная конфиденциальность и приватность вам гарантированы!",
  "site_keywords": "вирт, чат, онлайн, анон, без регистрации, анонимный чат, секс чат, chatroom, virtchat, chat-in-love, love-in-chat, virt-chat, meet-in-chat",
  "yes_change_region": "Да, сменить",
  "no_dont_touch_region": "Нет",
  "registration_confirmation": "Подтверждение регистрации:",
  "email_confirmed": "Email подтвержден, можете войти в чат",
  "link_is_wrong": "Ссылка по которой вы перешли неверная. Попробуйте с самого начала.",
  "email_confirmation": "Подтверждение почты",
  "registration": "Регистрация",
  "create_a_nickname": "Придумайте логин",
  "nickname_is_busy": "Логин уже занят, придумайте другой",
  "access_restoration": "Восстановления доступа:",
  "create_a_password": "Придумайте пароль",
  "hide_show_password": "Спрятать/Показать пароль",
  "fill_in_a_password": "Введите пароль",
  "password_to_long": "Пароль слишком длинный",
  "password_to_short": "Пароль слишком короткий",
  "password_only_from_digits": "Пароль должен содержать хотя бы одну букву",
  "repeat_the_password": "Повторите пароль",
  "wrong_password": "Пароль указан неверно",
  "password_not_equals": "Пароли не совпадают",
  "legal_age_confirmation": "Подтверждаю, что на момент регистрации я достиг/ла 18-летнего возраста",
  "confirmation_required": "Необходимо подтверждение",
  "confirmation_rules_1": "Подтверждаю, что я прочел/а",
  "confirmation_rules_2": "правила",
  "confirmation_rules_3": "и буду их соблюдать",
  "register": "Зарегистрироваться",
  "continue": "Продолжить",
  "home": "Главная",
  "access_restored_you_can_enter_with_new_password": "Доступ восстановлен, теперь Вы можете войти с новым паролем",
  "entrance": "Вход",
  "registration_complete": "Регистрация прошла успешно. Для продолжения проверьте Ваш email. Если вы не видите письмо, проверьте папку Спам",
  "access_restoration_step_2": "Восстановление доступа (шаг 2)",
  "access_restoration_step_1": "Восстановление доступа (шаг 1)",
  "email_with_confirmation_link_will_be_send": "Вам будет выслано письмо с подтверждением",
  "email_has_already_registered": "Данный email уже зарегистрирован",
  "email_is_incorrect": "Email введен неверно или незаполнен",
  "repeat_email": "Email (еще раз)",
  "you_should_solve_a_captcha": "Необходимо пройти капчу",
  "region": "Регион",
  "region_description": "Выбор региона определяет основной язык общения, а так же сервер к которому вы подключитесь. Сервера в разных регионах не связаны между собой",
  "close": "Закрыть",
  "check_internet_connection_and_try_again": "Произошла ошибка. Проверьте подключение к интернет или повторите позже",
  "email_instruction": "Если email был указан верно то Вы получите письмо с дальнейшими инструкциями. Проверьте Вашу почту",
  "to_contact_the_administration_write_to_email": "Для связи с администрацией пишите нам на почту ",
  "current_email": "ru-support@Virt-Chat",
  "contacts": "Контакты",
  "qa": "Q&A",
  "site_only_for_adult_footer": "Сайт предназначен для лиц старше 18 лет. Если вам менее 18 лет, Вы обязаны покинуть этот сайт. Вход в чат подтверждает что вам не менее 18 лет и означает Ваше согласие с ",
  "site_only_for_adult_footer_rules": "правилами",
  "site_only_for_adult_footer_and": " и ",
  "site_only_for_adult_footer_privacy_policy": "политикой конфиденциальности",
  "home_text": "<h1>ru.Virt-Chat – Ваше путешествие в мир наслаждения анонимно и без регистрации</h1><p>Вы устали проводить одинокие вечера дома и мечтаете расслабиться за пикантным общением в приятной компании? Тогда вы попали по адресу. Наш виртуальный чат – это интернет-портал, где возможно все и даже больше. Выбирайте любого собеседника, переписывайтесь, присылайте фото и гиф – и все это совершенно бесплатно. Воплотите в реальность свои мечты и насладитесь интимным разговором анонимно и без обязательств!</p><h2>Что скрывает анонимный интим-чат?</h2><p>Виртуальный секс – это самая популярная фантазия, которую имел каждый хотя бы раз в жизни. И теперь у вас появилась возможность воплотить ее в реальность.</p><p>Виртуальный секс чат без регистрации создан для общения взрослых людей на интимные, волнующие и интригующие темы. Здесь может найти своего собеседника как тот, кто никогда ранее не участвовал в подобных беседах, так и продвинутый пользователь секс-мессенджеров.</p><p>За что пользователи любят эротическую переписку?</p><ul><li>Она не ограничивает фантазии и желания. С каждым новым чатом пользователь познает новые варианты удовольствия;</li><li>Моментальная реализация желаний и множество тех, кто готов их разделить;</li><li>Много возможностей – приватный или общий чат, фото, гиф-анимации;</li><li>Обогащает фантазию путем обмена опытом.</li></ul><h2>Преимущества нашего бесплатного чата</h2><p>Наш анонимный чат не включает в себя регистрацию, чтобы сохранить данные пользователей в секрете. Чтобы вы почувствовали себя комфортно, мы не передаем ваши данные третьим лицам, чтобы пользователи могли общаться онлайн, без страха быть отслеженными. Почувствуйте полную свободу и получите удовольствие от интимного разговора!</p><p>Почему виртуальный секс так популярен? Мы ответим на этот вопрос, перечислив достоинства нашего сайта, где пользователь найдет:</p><ul><li>Возможность общения в привате;</li><li>Абсолютно бесплатное общение;</li><li>Полная конфиденциальность.</li></ul><p>Заходите на в наш виртуальный секс-чат, где можно моментально найти собеседника, с которым легко и непринужденно общаться на эротические темы без стеснения и фальши. Попробуйте удивить себя и своих партнеров игрой фантазии и полетом мысли, отпустите все правила в своей голове и насладитесь абсолютным удовольствием, которое способно принести виртуальное эротическое общение!</p>",
  "rules_title": "Правила пользования",
  "rules_header": "Правила пользования интим-чатом  ru.Virt-Chat",
  "rules_p1_1": "Интернет-портал ",
  "rules_p1_2": " предлагает бесплатную и добровольную авторизацию для общения на интимные темы. Пользователь, изъявивший желание приобщиться к чату, автоматически соглашается с описанными правилами и принимает условия данного соглашения.",
  "rules_p2": "После авторизации каждый пользователь сайта рассматривается администрацией как физическое лицо, достигшее допустимого возраста для общения на интимные темы. Лица, не достигшие 18 лет, обязаны прекратить использование портала и выйти из чата.",
  "rules_p3": "Авторизация на сайте предлагается на условиях полной анонимности, пользователь самостоятельно несет ответственность за предоставляемую во время переписки информацию",
  "rules_p4": "Руководство интим-портала не принуждает участников чата к общению, не предлагает темы и топики, не отвечает за действия или бездействие посетителей. Портал только лишь дает техническую возможность пользователю организовать свое общение. За всю информацию, размещенную на сайте, посетитель несет ответственность самостоятельно.",
  "rules_p5": "Администрация имеет право в любой момент изменить контент, дизайн, список сервисов и так далее без предупреждения пользователя. Если внесенные на сайт изменения не устраивают пользователя, то администрация настоятельно рекомендует его покинуть.",
  "rules_p6": "В интим-чате поощряется общение на интимные темы которые не запрещены законом.",
  "rules_p7": "Возможно размещение фотографий, смайлов, анимации, если на них не изображены дети, сцены убийств и насилия, секса с животными и другой запрещенный законом контент.",
  "rules_p8": "Разрешено общение без регистрации как в общем чате, так и приватном. Посетитель указывает только вымышленное имя и пол.",
  "rules_p9": "Не запрещается обмен опытом и персональными данными в личных сообщениях, если все участники переписки согласны на это.",
  "rules_p10_1": "На просторах интернет-портала ",
  "rules_p10_2": " категорически запрещены и караются БАНом:",
  "rules_p11": "Оскорбления и провокация участников чата.",
  "rules_p12": "Использование личной информации собеседника в любых целях без согласования с ним.",
  "rules_p13": "Распространять личные данные (имя, фамилия, номер телефона, фото и т.д.) людей которые не являются участниками чата и без согласования с ними",
  "rules_p14": "Распространение контента, запрещенного законом, а именно: инцеста, детской порнографии, а также намеки на них (использование специфических никнеймов, использование фраз намекающих на запрещенные темы и тому подобное).",
  "rules_p14_1": "Распространение контента, связанного с зоофилией.",
  "rules_p15": "Запрещено употреблять в разговоре нецензурную лексику (матерные слова) и непристойные выражения в общих комнатах",
  "rules_p16": "Запрещено добавлять фотографии, которые могут вызвать отвращение, например, копро, писсинг, акты с применением насилия и другие.",
  "rules_p17": "Запрещено размещать информацию и фотографии политического характера.",
  "rules_p18": "Массовая рассылка сообщений рекламного характера (спам).",
  "rules_p19": "Запрещено создавать комнаты названия которых намекает на запрещенные темы или в названии которых используется нецензурная лексика",
  "rules_p20": "Пользователь может быть заблокирован за то, что является участником комнаты, название которой намекает или прямо говорит о теме/темах запрещенных в данном чате",
  "rules_p21": "Запрещено использовать буквы и символы в названии, которые, искусственно помогают расположиться комнату в начале списка комнат, при этом не несут смысловой нагрузки.",
  "rules_p22": "Запрещено использовать высказывания на тему религии, которые могут оскорбить и обидеть других посетителей.",
  "rules_p23": "Запрещено использование клавиши CapsLock при написании текстовых сообщений.",
  "rules_p24": "Для общения в публичных комнатах запрещено использовать любой другой язык кроме русского.",
  "rules_p25": "Администрация сайта не занимается модерацией контента, исходящего от пользователей и их персональной информации.",
  "rules_p26": "Руководство интернет-сайта не несет ответственности за ущерб, в том числе косвенный, неумышленный и т.д., причиненный пользователям в результате общения внутри портала. Сайт и его администраторы никаким образом не отвечают за честь, достоинство и репутацию пользователей.",
  "rules_p27": "Руководство интернет-сайта НЕ предоставляет никакую информацию о других пользователях ни в каких формах другим пользователям",
  "rules_p28": "В случае нарушения правил модератор сайта имеет право сделать посетителю замечание и предупредить о возможном занесении в БАН.",
  "rules_p29": "Администраторы оставляют за собой право принимать решение о блокировке аккаунтов пользователей. Незнание положений, прописанных в пользовательском соглашении, не освобождает пользователя интим-чата от ответственности за нарушения.",
  "rules_p30": "Правила вступают в силу с того момента, как участник чата вошел в систему и указал данные для входа и действуют на протяжении всего времени, которое он проводит на сайте.",
  "rules_p31_1": "Данные правила могут меняться в любой момент без предварительного уведомления посетителей сайта. Актуальный список правил можно найти на странице ",
  "rules_p31_2": ".",
  "privacy_policy": "Политика конфиденциальности",
  "privacy_policy_for_site": "Политика конфиденциальности сайта",
  "privacy_policy_h3_1": "Введение",
  "privacy_policy_p1": "Конфиденциальность посетителей нашего сайта очень важна для нас, и мы стремимся к ее защите. В политике конфиденциальности содержится описание порядка обработки личной информации.",
  "privacy_policy_h3_2": "Сбор личной информации",
  "privacy_policy_p2": "Следующие типы личных данных могут быть собраны, сохранены и использованы:",
  "privacy_policy_ul1_1": "Информация о вашем устройстве, включая ваш IP-адрес, информация о вашем  браузере, а также операционной системе;",
  "privacy_policy_ul1_2": "Информация о ваших посещениях и использовании настоящего сайта, включая источник ссылок, продолжительность посещения, просмотры страниц и пути навигации по сайту;",
  "privacy_policy_ul1_3": "Информация, которую вы вводите при создании профиля на нашем сайте, например, пол, адрес электронной почты ;",
  "privacy_policy_ul1_4": "Информация, касающаяся всего, что вы покупаете, услуг, которые вы используете, или транзакций, которые вы совершаете через наш сайт, включая ваше имя, адрес, номер телефона, адрес электронной почты и данные кредитной карты;",
  "privacy_policy_ul1_5": "Информация, содержащаяся в любых сообщениях, которые вы отправляете нам по электронной почте или через наш сайт, включая содержание и метаданные;",
  "privacy_policy_ul1_6": "Любая другая информация, которую вы нам отправляете.",
  "privacy_policy_p3": "Прежде чем раскрывать нам личную информацию другого лица, вы должны получить согласие этого лица как на раскрытие, так и на обработку этой личной информации в соответствии с настоящей Политикой",
  "privacy_policy_h3_3": "Использование личной информации",
  "privacy_policy_p4": "Мы можем использовать вашу личную информацию для следующих целей:",
  "privacy_policy_ul2_1": "Администрирование нашего сайта и бизнеса;",
  "privacy_policy_ul2_2": "Персонализация нашего сайта для вас;",
  "privacy_policy_ul2_3": "Предоставление вам возможности пользоваться услугами, доступными на нашем сайте;",
  "privacy_policy_ul2_4": "Предоставление третьим лицам статистической информации о наших пользователях (но эти третьи лица не смогут идентифицировать какого-либо отдельного пользователя из этой информации);",
  "privacy_policy_ul2_5": "Работа с запросами и жалобами, сделанными вами или о вас, относящимися к нашему сайту;",
  "privacy_policy_ul2_6": "Для проведения статистических исследований",
  "privacy_policy_ul2_7": "Обеспечение безопасности нашего сайта и предотвращение мошенничества;",
  "privacy_policy_ul2_8": "Других целей.",
  "privacy_policy_h3_4": "Хранение данных и удаление",
  "privacy_policy_p5_1": "Пользователь, имеет право на удаление своих данных. Срок, в течение которого будут храниться ваши персональные данные: время, необходимое для использования данных для основной деятельности сайта и отслеживания статистики. При завершении использования ваших данных администрация сайта удаляет их. Для удаления своих персональных данных вы можете связаться с администрацией сайта. Адрес для связи можно найти на странице",
  "privacy_policy_p5_2": "Контакты",
  "privacy_policy_p5_3": ".",
  "privacy_policy_h3_5": "Безопасность вашей личной информации",
  "privacy_policy_p6": "Мы реализовали соответствующие технические и организационные меры безопасности, чтобы обеспечить защиту личной информации, которую мы обрабатываем. Однако следует иметь в виду, что мы не можем гарантировать полную безопасность интернета. Хотя мы предпринимаем все возможные меры для защиты вашей личной информации, передача этой информации через сеть интернет может представлять определенные риски, поэтому доступ к нашему сайту должен осуществляться только в безопасной среде.",
  "privacy_policy_h3_6": "Использование cookies",
  "privacy_policy_p7_1": "Для корректного отображения содержимого и для удобства использования сайта  ru.Virt-Chat мы используем cookie файлы. Это небольшие файлы, которые хранятся на вашем устройстве. Они помогают сайту запомнить информацию о вас, например на каком языке вы просматриваете сайт и какие страницы вы уже открывали, эта информация будет полезна при следующем посещении. Благодаря файлам cookie просмотр сайта становится значительно более удобным. Подробнее про эти файлы вы можете прочитать ",
  "privacy_policy_p7_2": "тут",
  "privacy_policy_p7_3": ". Вы можете настроить прием или блокировку cookie в браузере самостоятельно. Невозможность принимать cookie может ограничить работоспособность сайта.",
  "privacy_policy_h3_7": "Использование персональных данных другими сервисами",
  "privacy_policy_p8": "На этом сайте используются сторонние интернет-сервисы, осуществляющие независимый от нас сбор информации: Google Analytics , Yandex.Metrica, Sentry, RichAds и другие. Собранные ими данные могут предоставляться другим службам внутри этих организаций, они могут использовать данные для персонализации рекламы своей собственной рекламной сети.  Вы можете прочитать пользовательские соглашения этих организаций на их сайтах. Мы не контролируем и не несем ответственности за политику конфиденциальности и практику третьих лиц.",
  "privacy_policy_h3_8": "Изменения",
  "privacy_policy_p9": "Мы можем обновлять данную политику время от времени, публикуя новую версию на нашем сайте. Вы должны периодически проверять эту страницу, чтобы убедиться, что вы понимаете любые изменения в этой политике.",
  "privacy_policy_h3_9": "Обратная связь, заключительные положения",
  "privacy_policy_p10_1": "Контакты для связи с администрацией сайта  ru.Virt-Chat по вопросам, связанным с политикой конфиденциальности можно найти на странице ",
  "privacy_policy_p10_2": "Контакты",
  "privacy_policy_p10_3": ". Если вы не согласны с данной политикой конфиденциальности, вы не можете пользоваться услугами сайта  ru.Virt-Chat, в этом случае вы должны воздержаться от посещения нашего сайта.",
  "attention": "Внимание!",
  "are_you_over_18_years_old": "Вам исполнилось 18 лет?",
  "yes_it_is_true": "Да, исполнилось",
  "not_it_is_not_true": "Нет, не исполнилось",
  "anonymous_login": "Анонимный вход:",
  "login": "Ник",
  "forgot_a_password": "Забыли пароль?",
  "login_as_invisible": "Войти как невидимка",
  "your_gender": "Ваш пол",
  "choose_a_gender": "Выберите пол",
  "email": "Email",
  "not_receive_confirmation_email": "Не получили письмо для подтверждения email?",
  "send_email_one_more_time": "Отправить письмо еще раз",
  "or": "или",
  "enter": "Войти",
  "cancel": "Отменить",
  "enter_login": "Введите логин",
  "only_for_18_years_old": "Сайт предназначен только для лиц достигших 18 лет",
  "understand": "Понятно",
  "confirmation_sent_successfully": "Подтверждение отправлено. Если вы не видите письмо, проверьте папку Спам",
  "you_are_blocked": "Вы заблокированы за нарушение правил чата",
  "you_need_to_wait": "Блокировка продлится еще {{time}}",
  "update_available": "Мы кое что обновили, для правильной работы чата необходимо обновить страницу",
  "reload": "Обновить",
  "too_much_attempts_for_entrance": "Слишком много попыток ввода неверного пароля, перед следующей попыткой подождите {{time}}",
  "add_telegram_username_to_block_title": "Добавление пользователя Telegram для блокировки",
  "add_telegram_username_to_block_explanation": "Укажите логин из телеграм, можно как с @ впереди так и без",
  "telegram_username": "Логин из Телеграм",
  "telegram_username_successful_added": "Логин успешно добавлен",
  "telegram_username_added_error": "Логин не найден или произошла ошибка",
  "ban_words_h1": "Добавление нового слова в СТОП-лист",
  "ban_words_explanation": "Пожалуйста, будьте внимательны с добавлением новых слов, не добавляйте часто употребляемые слова, потому что в этом случае Вы заблокируете большую часть сообщений. Отличным вариантом для добавления являются логины скайпа, телеграма или номера телефонов",
  "blocked_word": "Блокируемое слово",
  "add": "Добавить",
  "edit": "Редактировать",
  "delete": "Удалить",
  "user_for_block": "Блокируем пользователя: {{who}}",
  "select_reason_for_blocking": "Выберите причину блокировку:",
  "block_for": "Блокируем на:",
  "why_we_are_blocking": "За что блокируем",
  "block": "Заблокировать",
  "user_for_deny_entry": "Запретить вход пользователю \"{{login}}\"",
  "reason_not_selected": "Необходимо выбрать причину",
  "chose_kick_reason": "Выберите причину",
  "kick_user_error": "Произошла ошибка при блокировке пользователя",
  "gender_change": "Смена пола",
  "to_change_gender": "Сменить пол",
  "gender_successfully_changed": "Пол изменен. Изменения вступят в силу после перезагрузки страницы",
  "about_me": "Сменить аватар",
  "avatar_presets_title": "Выберите аватар",
  "avatar_upload_button": "Загрузить свой аватар",
  "avatar_upload_hint": "JPEG, PNG или WEBP, до 10 МБ",
  "avatar_upload_success": "Аватар успешно загружен",
  "avatar_upload_error": "Не удалось загрузить аватар. Попробуйте ещё раз",
  "avatar_remove_button": "Удалить аватар",
  "avatar_premium_required": "Загрузка своего аватара доступна с Премиумом",
  "avatar_token_rate_limited": "Слишком много попыток загрузки аватара. Попробуйте позже",
  "avatar_invalid_hash": "Не удалось распознать загруженный файл. Попробуйте загрузить аватар заново",
  "avatar_rate_limited": "Слишком частая смена аватара. Попробуйте позже",
  "password_change": "Смена пароля",
  "password": "Пароль",
  "new_password": "Новый пароль",
  "repeat_new_password": "Повторите новый пароль",
  "to_change_password": "Сменить пароль",
  "password_successfully_changed": "Пароль изменен успешно",
  "balance": "Баланс",
  "make_payment": "Пополнить баланс",
  "your_balance_has_been_replenished_by": "Ваш баланс пополнен на {{amount}}",
  "has_been_debited_from_you": "C вас списано {{amount}}",
  "delete_account": "Удалить аккаунт",
  "cancel_delete_account": "Отменить удаление аккаунта",
  "delete_account_title": "Вы действительно хотите удалить аккаунт?",
  "delete_account_description": "Аккаунт будет удален через 7 дней после отправки заявки, на протяжении этого времени вы сможете отозвать её. <br> <span class=\"red-color\">После удаления аккаунта под вашим логином \"{{login}}\" сможет зайти кто угодно, так как аккаунт не будет привязан к вашей почте и не будет защищен вашим паролем</span>",
  "yes_delete_my_account": "Да, я хочу удалить мой аккаунт",
  "application_for_delete_account_accepted": "Заявка на удаление аккаунта успешно принята",
  "application_for_delete_account_canceled": "Удаление аккаунта отменено",
  "cancel_delete_account_confirmation": "Вы действительно хотите отменить удаление аккаунта?",
  "yes_cancel_account_delete": "Да, отменить удаление",
  "no_delete_my_account": "Нет, все еще хочу удалить аккаунт",
  "your_account_will_deleted_via": "Ваш аккаунт будет удален примерно через {{time}}",
  "unknown_error": "Что-то пошло не так, попробуйте пожалуйста позже",
  "add_word_to_block_list": "Добавить слово в СТОП-лист",
  "add_telegram_username_to_block": "Добавить пользователя Telegram для блокировки",
  "add_remove_roles": "Назначение/снятие ролей",
  "moderator_section": "Меню модератора",
  "sort_alphabet_asc": "По алфавиту (а-я)",
  "sort_alphabet_dsc": "По алфавиту (я-а)",
  "sort_alphabet": "По алфавиту",
  "sort_by_gender": "По полу",
  "sort_by_registered": "Зарегистрированные",
  "sort_by_guests": "Гости",
  "sound_alerts_settings": "Настройки звуковых уведомлений",
  "users_list_sort": "Сортировка списка пользователей",
  "log_in_log_out_messages": "Сообщения о входе/выходе пользователей",
  "add_watermark": "Добавлять водяной знак",
  "show_images": "Отображать изображения",
  "images_display_section": "Показ изображений",
  "images_display_chat": "Отправленные через чат",
  "images_display_external": "Внешние изображения",
  "external_images_warning_title": "Внешние изображения",
  "external_images_warning_body": "Загрузка внешних изображений может раскрыть ваш IP-адрес, данные об устройстве и другую информацию владельцу ресурса. Включайте только если доверяете источнику.",
  "external_images_warning_accept": "Понимаю риски, показать изображения",
  "external_images_warning_cancel": "Закрыть",
  "dont_show_again": "Больше не показывать",
  "disallow_private_messages": "Запретить входящие сообщения",
  "settings": "Настройки",
  "enable_disable_autoscroll": "Включить/отключить автопрокрутку сообщений",
  "you_dont_have_any_messages": "У Вас пока нет сообщений",
  "chats_with_non_read_messages": "Чаты с непрочитанными сообщениями",
  "show_hide_users_list": "Показать/скрыть список пользователей",
  "file_too_large": "Файл слишком большой. Максимальный размер файла 15 мб",
  "cant_send_image": "Не удалось отправить изображение",
  "cant_read_image_from_device": "Не удалось получить изображение с устройства",
  "your_complaint_has_been_accepted": "Спасибо. Ваша жалоба принята к рассмотрению",
  "you_cent_send_message_tou_yourself": "Нельзя писать сообщения самому себе",
  "you_cant_send_private_messages_in_invisible_mode": "В \"невидимке\" нельзя писать личные сообщения",
  "your_login_example": "ВашНик",
  "notifications_in_lobby": "В гостиной",
  "notifications_in_other_rooms": "В других комнатах",
  "notifications_in_private_messages": "В личных сообщениях",
  "notifications_on_replays": "В случае ответа (@{{login}})",
  "user_offline_cant_send_message": "Пользователь не в сети, невозможно отправить сообщение",
  "close_room_title": "Закрываем комнату: {{room}}",
  "close_reason": "Причина закрытия:",
  "block_room_creator": "Заблокировать создателя комнаты?",
  "block_room_members": "Заблокировать всех участников комнаты?",
  "please_use_this_very_carefully": "Пожалуйста, пользуйтесь этой опцией только в самых крайних случаях (например педофилия)",
  "to_block_room_creator_phrase_1": "Блокируем создателя",
  "to_block_room_creator_phrase_2": " и участников",
  "to_block_room_creator_phrase_3": " на:",
  "why_room_is_closing": "По какой причине закрываем комнату?",
  "close_the_room": "Закрыть комнату",
  "close_room_confirmation_message": "Вы уверены, что хотите закрыть комнату? Внимание: при закрытии комнаты деньги не возвращаются.",
  "room_closed": "Комната закрыта",
  "about_room": "О комнате",
  "info_about_room": "Информация о {{room}}",
  "creator_colon": "Создатель:",
  "moderators_colon": "Модераторы:",
  "description_colon": "Описание:",
  "chose_blocking_time": "Выберите время блокировки",
  "report": "Пожаловаться",
  "report_reason_child_port_zoo": "Детское порно / Зоо",
  "report_reason_member_under_18_yo": "Возраст участника меньше 18",
  "report_reason_spam": "Спам / Оскорбления и т.д.",
  "report_reason_commerce": "Услуги за деньги",
  "report_men_in_room_for_women": "Мужчина в женской комнате",
  "creating_room": "Создание комнаты",
  "room_title": "Название для комнаты",
  "fill_in_room_title": "Введите название комнаты",
  "room_title_too_short": "Название комнаты слишком короткое или содержит недопустимые символы",
  "room_title_too_long": "Название комнаты слишком длинное",
  "room_title_should_start_from_eng_or_rus_character": "Название комнаты должно начинаться с английской или русской буквы",
  "password_if_you_want": "Пароль, если необходимо",
  "password_too_long": "Пароль слишком длинный",
  "password_too_short": "Пароль слишком короткий",
  "additional_parameters_for_room_creation": "Дополнительно:",
  "paid_room": "Премиум комната",
  "paid_room_price": "{{price}} в месяц",
  "paid_room_description": "Ваша комната — ваши правила! Станьте полноправным владельцем: устанавливайте свои порядки, назначайте модераторов и полностью контролируйте доступ. Создайте идеальное пространство для общения.",
  "paid_room_details": "Данная опция позволит вам:\n• Стать администратором комнаты\n• Назначать других пользователей модераторами\n• Устанавливать правила для посетителей\n• «Выгонять» и запрещать вход нарушителям",
  "paid_room_settings": "Настройки комнаты",
  "unpaid_room_warning": "Ваша комната «{{roomTitle}}» не оплачена и скрыта от пользователей. Пожалуйста, пополните баланс.",
  "low_balance_upcoming_charge_warning": "С вашего счета через {{daysLeft}} {{daysPlural}} будет списана оплата за комнату «{{roomTitle}}», но у вас недостаточно средств. Пожалуйста, пополните баланс.",
  "deposit_money": "Пополнить баланс",
  "add_moderator": "Выдать права модератора",
  "remove_moderator": "Отобрать права модератора",
  "only_premium_can_be_moderator": "Модератором можно назначить только пользователя с премиум статусом.",
  "user_not_a_room_moderator": "Пользователь не является модератором",
  "user_name_should_be_entered_in_full": "Логин пользователя необходимо ввести так, как он отображается в списке пользователей",
  "moderator_role_has_been_successfully_assigned": "Роль модератора успешно назначена",
  "moderator_role_has_been_successfully_took_off": "Роль модератора успешно отобрана",
  "edit_pinned_message": "Изменить закрепленное сообщение",
  "editing_pinned_message": "Изменение закрепленного сообщения",
  "allowed_tags": "Разрешено использовать следующие теги: {{tags}}",
  "preview": "Предпросмотр:",
  "changes_successfully_applied": "Изменения успешно применены",
  "change": "Изменить",
  "assign": "Назначить",
  "take_off": "Отобрать",
  "user_not_found": "Пользователь не найден",
  "user_not_premium": "У пользователя отсутствует премиум статус",
  "user_banned": "Запрещено делать пользователя модератором если на него наложен бан",
  "user_already_moderator": "Пользователь уже является модератором данной комнаты",
  "allowed_only_to_registered": "Разрешить вход только зарегистрированным пользователям",
  "allowed_only_to_registered_error": "Вход разрешен только зарегистрированным пользователям",
  "which_gender_can_enter_into_room": "Какой пол может входить в комнату",
  "choose_who_can_enter_into_room": "Кто может входить в комнату",
  "create_room_attention": "Внимание! Если название комнаты не соответствует правилам чата - она будет принудительно закрыта модераторами, а автор заблокирован",
  "create": "Создать",
  "warning": "Внимание",
  "loosed_connection_with_server": "Связь с сервером потеряна. Проверьте подключение к Интернет",
  "enter_again": "Войти снова",
  "message": "Сообщение",
  "type_in_message": "Наберите сообщение",
  "send_message": "Отправить сообщение",
  "send_image": "Отправить изображение",
  "show_hide_emoji": "Показать/скрыть панель с эмо́джи",
  "answer": "Ответить",
  "block_user": "Заблокировать пользователя",
  "block_user_commerce": "Заблокировать (коммерция)",
  "block_user_child_porn": "Заблокировать (ДП)",
  "block_user_age": "Заблокировать (Возраст)",
  "deny_entry": "Запретить вход",
  "remove_message": "Удалить сообщение",
  "private_message": "Приват",
  "ignore": "Игнорировать",
  "not_ignore": "Не игнорировать",
  "load_image_error": "Тут должна быть картинка, но что-то пошло не так",
  "login_for_search": "Логин",
  "enter_login_for_search": "Введите ник",
  "find": "Найти",
  "user": "Пользователь",
  "roles": "Роли:",
  "administrator": "Администратор",
  "role_admin_description": "(может назначать роли, блокировать модераторов и администраторов)",
  "moderator": "Модератор",
  "role_moderator_description": "(может блокировать пользователей, закрывать комнаты, удалять сообщения)",
  "save": "Сохранить",
  "failed_to_find_anybody": "Никого не удалось найти",
  "something_goes_wrong_try_later": "Что-то пошло не так, попробуйте пожалуйста позже",
  "roles_changed": "Роли успешно изменены",
  "for_room_entering_need_password_title": "Для входа в комнату \"{{room}}\" необходимо ввести пароль",
  "fill_in_a_password_for_room_entrance": "Введите пароль для входа в комнату",
  "search": "Поиск",
  "clear_search_field": "Очистить поле поиска",
  "rooms": "Комнаты:",
  "create_room": "Создать комнату",
  "users": "Пользователи",
  "error_connect": "Невозможно подключиться. Попробуйте позже",
  "error_server": "Что-то пошло не так. Попробуйте позже или напишите нам на email",
  "wrong_gender": "Пол указан неверно",
  "login_too_short": "Ник слишком короткий",
  "login_is_used": "Данный ник уже занят, придумайте другой",
  "spaces_not_allowed_in_login": "Запрещено использовать пробел в нике",
  "you_are_bot": "У нас есть подозрение что Вы бот, а ботам тут не место!",
  "error_en_ru_chars_together": "Запрещено использовать одновременно буквы из разных языков в логине",
  "error_vpn_used": "У нас есть подозрение что Вы используете VPN или прокси. Отключите VPN или прокси и попробуйте еще раз",
  "email_is_busy": "Данный email уже используется",
  "email_or_code_is_wrong": "Данные переданы неверно или email уже подтвержден",
  "restore_data_is_wrong": "Данные переданы неверно или доступ уже восстановлен",
  "restore_code_link_expire": "Время жизни ссылки истекло, попробуйте еще раз с самого начала",
  "delay_before_confirmation_send": "Предыдущее письмо было отправлено менее чем сутки назад. Подождите немного перед попыткой отправить письмо повторно. Если не нашли письмо проверьте папку Спам",
  "unknown_user_or_email_confirmed": "Пользователь не найден или email уже подтвержден",
  "email_not_confirmed": "Для продолжения необходимо подтвердить email",
  "delay_before_restoration_send": "Прошло менее часа с предыдущей попытки восстановления. Проверьте Ваш email, так же проверьте папку Спам если не смогли нейти письмо",
  "user_is_blocked": "Пользователь заблокирован",
  "login_too_long": "Ник слишком длинный",
  "message_to_long": "Сообщение слишком длинное",
  "email_incorrect": "Email указан не верно",
  "incorrect_symbols_in_login": "Использованы недопустимые символы @ или .",
  "other_incorrect_symbols_in_login": "Использованы недопустимые символы",
  "passwords_not_equals": "Пароли не совпадают",
  "emails_not_equals": "Email-ы не совпадают",
  "too_many_attempts_to_change_password": "Слишком много попыток ввода неверного пароля",
  "gender_was_changed_recently": "Пол был уже недавно изменен. Попробуйте через 24 часа",
  "no_privileges": "Недостаточно полномочий для выполнения действия",
  "room_creating_only_for_registered": "Создавать комнаты могут только зарегистрированные пользователи",
  "you_have_created_too_many_rooms": "Вы создали слишком много комнат",
  "not_enough_money": "Недостаточно денег на счету",
  "room_not_paid": "Комната не оплачена. Вход разрешен только владельцу.",
  "room_with_name_already_exist": "Комната с таким именем уже существует",
  "complain": "Пожаловаться",
  "room_responsibility_title": "Важное предупреждение",
  "room_responsibility_text": "Вы несёте ответственность за соблюдение правил в этой комнате. Если вы видите запрещённый контент — немедленно подайте жалобу: нажмите на ник отправителя → “Пожаловаться”. Если в комнате будет обнаружено нарушение правил то комната будет закрыта с блокировкой ВСЕХ участников.",
  "room_responsibility_confirm": "Понимаю и продолжаю",
  "room_responsibility_exit": "Выйти из комнаты",
  "complaint_reason_child_port_zoo": "Детское порно / Зоо",
  "complaint_reason_member_under_18_yo": "Возраст участника меньше 18",
  "complaint_reason_spam": "Спам / Оскорбления и т.д.",
  "complaint_reason_commerce": "Услуги за деньги",
  "men_in_room_for_women": "Мужчина в женской комнате",
  "message_blocked": "Сообщение заблокировано",
  "to_many_messages": "Вы отправляете слишком много сообщений, помедленнее пожалуйста.",
  "to_many_images_in_main_chat": "Изображения в Гостиную можно отправлять не чаще, чем раз в {{period}}",
  "not_enough_time_after_login": "Изображения в Гостиную можно отправлять не ранее чем через 5 минут после входа",
  "user_block_error_first_part": "Не удалось заблокировать пользователя {{user}}, потому что ",
  "block_error_reason_user_not_found": "пользователь не найден",
  "block_error_reason_user_bot_or_admin": "пользователь бот или админ",
  "block_error_reason_unknown_reason": "неизвестная причина",
  "block_error_reason_you_dont_have_permissions": "Вы не имеете прав на блокировку пользователей",
  "block_error_reason_user_already_warned": "пользователь уже был предупрежден.",
  "user_blocked": "Пользователь заблокирован",
  "user_warned": "Пользователю показано предупреждение",
  "gender_cant_enter_to_room": "В комнату запрещен вход для {{gender}}",
  "cant_enter_gender_girls": "девушек",
  "cant_enter_gender_boys": "парней",
  "cant_enter_gender_trans": "трансов",
  "blocked_users_list": "Заблокированные пользователи",
  "manage_ban_reasons": "Управление причинами бана",
  "theme_section": "Тема",
  "theme_light": "Светлая",
  "theme_dark": "Темная",
  "theme_system": "Как в системе",
  "add_new_reason": "Добавить новую причину",
  "remove_messages": "Удалить сообщения",
  "no_ban_reasons_configured": "Причины блокировки еще не настроены",
  "title": "Заголовок",
  "description": "Описание",
  "blocking_time": "Время блокировки (часы)",
  "remove_user_messages": "Удалить сообщения пользователя",
  "failed_to_load_ban_reasons": "Не удалось загрузить причины бана",
  "error_loading_ban_reasons": "Ошибка загрузки причин бана",
  "title_is_required": "Заголовок обязателен",
  "blocking_time_hint": "От 1 до 168 часов",
  "please_check_form_errors": "Пожалуйста, проверьте ошибки формы",
  "ban_reason_saved_successfully": "Причина блокировки успешно сохранена",
  "failed_to_save_ban_reason": "Не удалось сохранить причину бана",
  "error_saving_ban_reason": "Ошибка сохранения причины бана",
  "ban_reason_deleted_successfully": "Причина бана успешно удалена",
  "error_deleting_ban_reason": "Ошибка удаления причины бана",
  "confirm_delete_ban_reason": "Подтвердите удаление причины бана",
  "unblock_user": "Разблокировать пользователя",
  "login_fro_unblock": "Логин кого разблокируем",
  "unblock": "Разблокировать",
  "user_unblocked": "Пользователь \"{{login}}\" разблокирован",
  "blocked_users": "Заблокированные пользователи",
  "transactions": "Транзакции",
  "no_transactions_found": "Транзакции не найдены",
  "date": "Дата",
  "failed_to_load_transactions": "Не удалось загрузить транзакции",
  "filter_by_username": "Фильтр по имени пользователя",
  "reason": "Причина",
  "will_be_unblocked": "Будет разблокирован",
  "permanently_banned_users_not_shown": "Перманентно заблокированные пользователи не отображаются в списке",
  "connection_restored_after_disconnection": "Связь с чатом восстановлена после разрыва соединения",
  "user_disallow_private_messages": "Пользователь запретил слать ему личные сообщения",
  "you_disallow_private_messages": "Вы запретили слать личные сообщения",
  "moderator_cant_disable_private_messages": "Модераторы не могут отключать личные сообщения",
  "too_many_registrations_from_ip": "Мы обнаружили слишком много попыток зарегистрироваться в вашего ip адреса",
  "kicked_from_room": "Вам запретили вход в комнату \"{{room}}\"",
  "kicked_from_room_error": "Модераторы комнаты \"{{room}}\" запретили вам вход",
  "nothing_found": "Ничего не найдено",
  "would_you_like_to_send_an_image_to_chat": "Желаете отправить изображение в чат?",
  "yes_send": "Да, отправить",
  "chat_moderators": "Модераторы чата",
  "managing_moderators": "Управление модераторами",
  "permissions_count": "разрешений",
  "permission_add_remove_moderators": "Управление модераторами",
  "permission_edit_pinned_message": "Редактирование описания комнаты",
  "permission_edit_ban_reasons": "Редактирование причин бана",
  "permission_unblock_users": "Разблокировка пользователей",
  "permission_admin": "Администратор",
  "permission_moderator": "Может блокировать пользователей",
  "no_moderators_found": "Модераторы не найдены",
  "moderator_permissions_updated": "Права модератора обновлены",
  "error_updating_permissions": "Ошибка при обновлении прав",
  "moderator_removed_successfully": "Модератор успешно удален",
  "error_removing_moderator": "Ошибка при удалении модератора",
  "confirm_remove_moderator": "Вы уверены, что хотите удалить модератора {{login}}?",
  "username": "Имя пользователя",
  "select_permissions": "Выберите права",
  "username_required": "Имя пользователя обязательно",
  "exit": "Выход",
  "exit_prompt": "Вы действительно хотите выйти?",
  "exit_yes": "Да, выйти",
  "yes": "Да",
  "no": "Нет",
  "lobby_room": "Гостиная",
  "admins_room": "Админка",
  "block_list_room": "Блокировки",
  "amount_is_to_small": "Сума слишком маленькая",
  "amount_is_to_high": "Сума слишком большая",
  "payment_initialization_error": "Произошла ошибка при инициализации платежа",
  "payment_error": "Произошла ошибка платежа",
  "service_phrases": {
    "enter": {
      "male": "{{login}} вошел в чат",
      "female": "{{login}} вошла в чат"
    },
    "exit": {
      "male": "{{login}} вышел из чата",
      "female": "{{login}} вышла из чата"
    }
  },
  "ok": "Ок",
  "sex": {
    "female": "Женщина",
    "male": "Мужчина",
    "trans": "Транс",
    "girls": "Девушки",
    "boys": "Парни",
    "shemales": "Трансы"
  },
  "days": {
    "zero": "дней",
    "one": "день",
    "two": "дня",
    "few": "дня",
    "many": "дней",
    "other": "дней"
  },
  "hours": {
    "zero": "часов",
    "one": "час",
    "two": "часа",
    "few": "часа",
    "many": "часов",
    "other": "часов"
  },
  "minutes": {
    "zero": "минут",
    "one": "минута",
    "two": "минуты",
    "few": "минуты",
    "many": "минут",
    "other": "минут"
  },
  "seconds": {
    "zero": "секунд",
    "one": "секунда",
    "two": "секунды",
    "few": "секунды",
    "many": "секунд",
    "other": "секунд"
  },
  "blog_title": "Блог",
  "back_to_blog": "Назад к блогу",
  "make_payment_dialog_title": "Оплата",
  "amount_label": "Сумма",
  "placeholder_example": "например, 10",
  "hint_min_max": "Минимум {{min}}, максимум {{max}}",
  "error_required": "Введите сумму",
  "error_integer": "Введите целое число",
  "error_min": "Минимальная сумма {{min}}",
  "error_max": "Максимальная сумма {{max}}",
  "pay": "Оплатить",
  "pay_with_telegram_stars": "Оплатить через Telegram Stars",
  "pay_with_crypto": "Оплатить криптовалютой",
  "choose_payment_method": "Выберите способ оплаты",
  "back": "Назад",
  "choose_telegram_stars_package": "Выберите пакет пополнения",
  "telegram_stars_package_option": "{{units}} ед. — {{stars}} ⭐",
  "telegram_stars_opening_bot": "Открываем Telegram: подтвердите оплату в боте",
  "telegram_package_not_found": "Этот пакет больше недоступен, выберите его заново",
  "telegram_only_for_registered": "Оплата через Telegram Stars доступна только зарегистрированным пользователям",
  "telegram_stars_disabled": "Оплата через Telegram Stars временно недоступна",
  "premium": "Премиум",
  "buy_premium": "Премиум",
  "premium_benefits": "Преимущества Премиума",
  "premium_benefit_1": "Золотая корона рядом с вашим ником",
  "premium_benefit_2": "Приоритет в списке пользователей",
  "premium_benefit_3": "Никакой рекламы — наслаждайтесь общением без пауз и баннеров",
  "premium_benefit_4": "Ваша приватность — возможность полностью отключить личные сообщения",
  "premium_benefit_5": "Увеличенные лимиты на сообщения и картинки в Гостиной",
  "premium_benefit_6": "Избранное без границ — добавляйте даже анонимных собеседников, чтобы не терять их из виду",
  "premium_benefit_7": "Свой аватар — загружайте любое изображение вместо готовых вариантов",
  "premium_benefit_8": "Дальше — больше! Мы постоянно работаем над новыми эксклюзивными функциями для наших премиум-пользователей.",
  "premium_price_for_month": "Цена за 1 месяц:",
  "buy_now": "Купить сейчас",
  "premium_purchased_success": "Премиум успешно приобретен!",
  "buy_premium_disabled": "Покупка премиума временно отключена",
  "premium_only_for_registered": "Покупка премиума доступна только для зарегистрированных пользователей",
  "premium_until": "Премиум до {{date}}",
  "your_premium_active_until": "Ваш премиум активен до: {{date}}",
  "extend_premium": "Продлить премиум",
  "boost_in_users_list": "Подняться в списке пользователей",
  "premium_only_feature": "Эта функция доступна только для премиум-пользователей",
  "premium_upsell_reminder": "Премиум открывает дополнительные возможности чата",
  "disable_private_messages": "Отключить личные сообщения"
}